import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Plus } from "lucide-react";

export default function Branches() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const load = async () => setList((await api.get("/branches")).data);
  useEffect(() => { load(); }, []);
  const save = async () => {
    try { if (editing.id) await api.put(`/branches/${editing.id}`, editing); else await api.post("/branches", editing);
      toast.success("Saved"); setOpen(false); load();
    } catch (e) { toast.error(apiError(e)); }
  };
  return <div className="space-y-6" data-testid="branches-page">
    <div className="flex items-start justify-between flex-wrap gap-4">
      <div><div className="overline">Company</div><h1 className="font-serif text-4xl mt-1">Branches</h1></div>
      <Button className="gold-bg" onClick={() => { setEditing({ name: "", active: true }); setOpen(true); }} data-testid="new-branch-btn"><Plus className="w-4 h-4 mr-2" />Add Branch</Button>
    </div>
    <div className="border rounded-md overflow-x-auto"><table className="plutus"><thead><tr><th>Name</th><th>Status</th><th></th></tr></thead>
      <tbody data-testid="branches-list">{list.map(b => <tr key={b.id}>
        <td className="font-medium">{b.name}</td>
        <td><span className={`pill ${b.active ? "pill-active" : "pill-inactive"}`}>{b.active ? "Active" : "Inactive"}</span></td>
        <td className="text-right"><button className="text-sm gold hover:underline" onClick={() => { setEditing({ ...b }); setOpen(true); }} data-testid={`edit-branch-${b.id}`}>Edit</button></td>
      </tr>)}{list.length === 0 && <tr><td colSpan={3} className="text-center py-8 text-muted-foreground">No branches yet.</td></tr>}</tbody></table></div>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent><DialogHeader><DialogTitle>{editing?.id ? "Edit Branch" : "Add Branch"}</DialogTitle></DialogHeader>
        {editing && <div className="space-y-4"><div><Label>Name *</Label><Input value={editing.name} onChange={e => setEditing({ ...editing, name: e.target.value })} data-testid="branch-name-input" /></div>
          <div className="flex items-center gap-3"><Switch checked={editing.active} onCheckedChange={v => setEditing({ ...editing, active: v })} data-testid="branch-active-switch" /><Label>Active</Label></div></div>}
        <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button><Button className="gold-bg" onClick={save} data-testid="save-branch-btn">Save</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  </div>;
}
